/**
 * The IBitmapDrawable interface is implemented by objects that can be passed as the
 * source parameter of the <code>draw()</code> method of the BitmapData class. These
 * objects are of type BitmapData or DisplayObject.
 * 
 * @see away.base.BitmapData#draw()
 * @see away.base.BitmapData
 * @see away.base.DisplayObject
 */
interface IBitmapDrawable
{

}

export default IBitmapDrawable;
